import { useIsMounted } from "./useIsMounted"

type BuildDonateUrlWithQueryStringResponse = {
  buildDonateUrlWithQueryString: (pageUrl: string, showEmbeddedCheckout: boolean) => string
}

export const useBuildDonateUrlWithQueryString = (): BuildDonateUrlWithQueryStringResponse => {
  const isMounted = useIsMounted()

  const buildDonateUrlWithQueryString = (pageUrl: string, showEmbeddedCheckout: boolean)=> {
    const urlParams = new URLSearchParams(isMounted ? window.location.search : {});
    const donateUrlParams = new URLSearchParams();
  
    donateUrlParams.append('startedBy', 'webjustgiving');
  
    if (showEmbeddedCheckout) {
      donateUrlParams.append('checkoutMode', 'Headless');
    }
  
    const utmSource = urlParams.get('utm_source');
    if (utmSource) {
      donateUrlParams.append('reference', utmSource);
    }
  
    return donateUrlParams.toString() ? `${pageUrl}/donate?${donateUrlParams.toString()}` : `${pageUrl}/donate`;
  }

  return { buildDonateUrlWithQueryString };
}
